const $ = require('jquery/dist/jquery');

window.$ = $;
window.jQuery = $;

const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
// Import Swiper and modules
// Import Swiper and modules
const Carousel = require('../../../carousel/client/js');
const config = require('./config');
const AjaxClient = require('../../../ajax/client/js');

/**
 * Client/browser JS for tabs
 * @param {string} selector jQuery selector
 * @param {function} onComponentLoaded function to capture the event of a new component loaded by ajax
 */
module.exports = {
    TabsClient: function fn(selector = '[data-component="Tabs"]', onComponentLoaded = () => {}, configuration = {}) {
        if (elementExist(`${selector} [data-component="Carousel"][data-navigation]`)) {
            /* Config */
            const configTabs = {
                ...config,
                ...configuration,
                swiper: { ...config.swiper, ...(configuration.swiper || {}) }
            };

            // Creating carousel instance
            Carousel(`${selector} [data-component="Carousel"][data-navigation]`, configTabs);
        }

        const $container = $(`${selector}`);

        $container.find('.js-nav-tabs').on('click', event => {
            if ($(event.currentTarget).hasClass('js-nav-tabs') && !$(event.currentTarget).hasClass('selected')) {
                const element = $(event.currentTarget);
                const targetId = element.attr('data-target');
                const placeholderId = $container
                    .find(`.js-content-tabs#${targetId}`)
                    .children()
                    .attr('id');

                const dataLink = element.attr('data-link');

                if (dataLink) {
                    event.preventDefault();
                }

                switchSelected(element, targetId, placeholderId);

                const sent = element.attr('data-sent');

                if (sent === '0' && placeholderId) {
                    ajaxCall(element, placeholderId);
                }
            }
        });

        function ajaxCall(element, placeholderId) {
            if (placeholderId) {
                const ajaxComponent = AjaxClient.init(placeholderId);
                ajaxComponent.load().then(
                    response => {
                        onComponentLoaded(placeholderId, response);
                        element.attr('data-sent', 1);
                    },
                    error => {
                        console.error(error);
                        document.querySelector(`#${placeholderId}`).innerHTML =
                            '<p style="text-align: center">Component did not load correctly</p>';
                        element.attr('data-sent', 0);
                    }
                );
            }
        }

        function switchSelected(element, targetId, placeholderId) {
            $container.find('.js-nav-tabs').removeClass('selected');
            element.addClass('selected');

            $container.find('.js-content-tabs').removeClass('enable');
            $container.find(`.js-content-tabs#${targetId}`).addClass('enable');

            if (element.attr('data-sent') === '1' && placeholderId) {
                onComponentLoaded(placeholderId);
            }
        }
    }
};
